import { render, staticRenderFns } from "./appItem.vue?vue&type=template&id=4e52040c&scoped=true&"
import script from "./appItem.vue?vue&type=script&lang=js&"
export * from "./appItem.vue?vue&type=script&lang=js&"
import style0 from "./appItem.vue?vue&type=style&index=0&id=4e52040c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e52040c",
  null
  
)

export default component.exports